export var Theme;
(function (Theme) {
    Theme["Light"] = "light";
    Theme["Dark"] = "dark";
})(Theme || (Theme = {}));
/**
 * @deprecated Pixel will be deleted from package
 */
export var PixelEventType;
(function (PixelEventType) {
    PixelEventType["AddPaymentInfo"] = "AddPaymentInfo";
    PixelEventType["AddToCart"] = "AddToCart";
    PixelEventType["AddToWishlist"] = "AddToWishlist";
    PixelEventType["CompleteRegistration"] = "CompleteRegistration";
    PixelEventType["Contact"] = "Contact";
    PixelEventType["CustomizeProduct"] = "CustomizeProduct";
    PixelEventType["Donate"] = "Donate";
    PixelEventType["FindLocation"] = "FindLocation";
    PixelEventType["InitiateCheckout"] = "InitiateCheckout";
    PixelEventType["Lead"] = "Lead";
    PixelEventType["PageView"] = "PageView";
    PixelEventType["Purchase"] = "Purchase";
    PixelEventType["Schedule"] = "Schedule";
    PixelEventType["Search"] = "Search";
    PixelEventType["StartTrial"] = "StartTrial";
    PixelEventType["SubmitApplication"] = "SubmitApplication";
    PixelEventType["Subscribe"] = "Subscribe";
    PixelEventType["ViewContent"] = "ViewContent";
})(PixelEventType || (PixelEventType = {}));
export var PredefinedEventTypes;
(function (PredefinedEventTypes) {
    PredefinedEventTypes["Default"] = "default-event";
    PredefinedEventTypes["Play"] = "play";
    PredefinedEventTypes["Stop"] = "stop";
})(PredefinedEventTypes || (PredefinedEventTypes = {}));
export var DefaultEventNames;
(function (DefaultEventNames) {
    DefaultEventNames["ShareButton"] = "share-button-click";
    DefaultEventNames["Button"] = "button-click";
    DefaultEventNames["CardBase"] = "card-base-click";
    DefaultEventNames["Link"] = "link-click";
    DefaultEventNames["ReactPlayerControls"] = "react-player-controls-click";
    DefaultEventNames["YandexFormSubmit"] = "yandex-form-submit";
    DefaultEventNames["HubspotFormSubmit"] = "hubspot-form-submit";
    DefaultEventNames["QuoteButton"] = "quote-button-click";
    DefaultEventNames["BackLink"] = "back-link-click";
    DefaultEventNames["Breadcrumb"] = "breadcrumb-click";
})(DefaultEventNames || (DefaultEventNames = {}));
